import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import map from 'lodash/map';
import styled from 'styled-components';
import { withTranslation } from 'react-i18next';

import * as actionCreators from '@src/store/actions';
import { getThemeSelector } from '@src/store/selectors';
import { handleThemeClick } from '@src/utils/theme';
import { getLanguageNameI18nKey } from '@src/const/common';
import { GlobeIcon } from '@src/components/common/icons/GlobeIcon';
import classStyle from './Footer.module.less';
import CopyRight from './CopyRight';
import PoweredBy from './PoweredBy';
import LanguageSettingModal from './languageSettingModal';

const LanguageWrapper = styled.div`
	padding-left: 24px;
`;

const StyleGlobeIcon = styled(GlobeIcon)`
	margin-right: 5px;
	position: absolute;
`;

class Footer extends React.Component {
	state = {
		modalStatus: false,
	};

	handleItemClick = item => {
		const { pages } = this.props;
		const { openType, link, paramId } = item;

		handleThemeClick({ openType, link, paramId, pages });
	};

	renderItem = (item, index) => {
		const { name, isDefault } = item;
		const { textColorStyle } = this.handleGetColorStyle();

		// 先隱藏 『申請成為經銷商』＋『訂閱電子報』
		if (isDefault) {
			return null;
		}

		return (
			<div
				key={index}
				role="presentation"
				className={classStyle.item}
				style={textColorStyle}
				onClick={() => this.handleItemClick(item)}
			>
				{name}
			</div>
		);
	};

	handleGetColorStyle = () => {
		const { footerContent, item, isThemeEdit } = this.props;
		const content = isThemeEdit ? item : footerContent;
		const { backColor, textColor } = content;
		const backColorStyle = {
			backgroundColor: backColor,
		};
		const textColorStyle = {
			color: textColor,
		};

		return {
			backColorStyle,
			textColorStyle,
		};
	};

	render() {
		const {
			footerContent,
			item,
			isThemeEdit,
			closedWeb,
			t,
			i18n,
		} = this.props;
		const content = isThemeEdit ? item : footerContent;
		const { list } = content;
		const { backColorStyle, textColorStyle } = this.handleGetColorStyle();
		return (
			<div id="footer" className={classStyle.footer} style={backColorStyle}>
				<LanguageSettingModal
					isActive={this.state.modalStatus}
					handleClose={() => this.setState({ modalStatus: false })}
					headerText={t('common:language:modal_title')}
				/>
				<div className={classStyle.list}>
					{map(list, this.renderItem)}
					<div
						role="presentation"
						className={classStyle.item}
						style={textColorStyle}
						onClick={() => {
							this.setState({ modalStatus: true });
						}}
					>
						<StyleGlobeIcon />
						<LanguageWrapper>
							{t(getLanguageNameI18nKey(i18n.language))}
						</LanguageWrapper>
					</div>
				</div>
				{
					!closedWeb && (
						<div className={classStyle.bottomDiv}>
							<div className={classStyle.version} style={textColorStyle}>
								<CopyRight />
							</div>
							<PoweredBy textColorStyle={textColorStyle} />
						</div>
					)
				}
			</div>
		);
	}
}

function mapStateToProps(state) {
	const {
		pages,
		themes: {
			closed_web,
		},
		footerContent,
	} = getThemeSelector(state);

	return {
		pages,
		footerContent,
		closedWeb: closed_web,
	};
}

function mapDispatchToProps(dispatch) {
	return {
		actions: bindActionCreators({ ...actionCreators }, dispatch),
	};
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(Footer));
